import EventEmitter from 'wolfy87-eventemitter';
import 'whatwg-fetch';

class Count extends EventEmitter {
    constructor(opts) {
        super();

        this.options = {
            endpoint: '/api/stats/count',
            delay: 10000,
            ...opts,
        };

        this.sync = this.sync.bind(this);

        this.count = null;
        this.timer = null;
    }

    start() {
        if (this.started) {
            return;
        }
        this.started = true;
        this.sync();
    }

    stop() {
        if (!this.started) {
            return;
        }
        this.started = false;
        if (this.timer !== null) {
            clearTimeout(this.timer);
        }
    }

    sync() {
        const { endpoint, delay } = this.options;
        return fetch(endpoint, {
            method: 'GET',
        })
        .then(response => response.json())
        .then((data) => {
            const count = parseInt(data.count, 10);
            if (count !== this.count) {
                this.count = count;
                this.emit('change', data);
            }

            if (this.started) {
                this.timer = setTimeout(this.sync, delay);
            }
        });
    }
}

export default Count;



// WEBPACK FOOTER //
// ./lib/Count.js